export default __webpack_public_path__ + "static/media/youtube.9a991bb9.svg";